import { KOGTableCell, KOGTableRow } from "@/main/components/shared/kogBoxGrid/styles";
import { TextEllipsis } from "@/main/components/shared/styles";
import { VoucherSearchGridItemResponse } from "@/main/models/response";
import { textOrEmptyValue } from "@/main/screens/order/refunds/refundsScreenUtils";
import { formatCurrency } from "@/main/services/utilsNumber";

interface ITextCell {
	value: string | null | undefined;
}

interface IRowRefund {
	refund: VoucherSearchGridItemResponse;
	index: number;
	showPrices: boolean;
}

function TextCell({ value }: Readonly<ITextCell>) {
	const text = textOrEmptyValue(value);

	return (
		<KOGTableCell>
			<TextEllipsis title={text}>{text}</TextEllipsis>
		</KOGTableCell>
	);
}

export default function RowRefund({ refund, index, showPrices }: Readonly<IRowRefund>) {
	return (
		<KOGTableRow $notHover $notClickable $isSizeLong id={`id-refunds-row-${index}`}>
			<TextCell value={refund.claimReportNumber} />
			<TextCell value={refund.insurerName} />
			<TextCell value={refund.voucherTypeName} />
			<TextCell value={refund.companyName} />
			<TextCell value={refund.vehicleDescription} />
			<TextCell value={refund.claimPartDescription} />
			<TextCell value={refund.voucherCode} />
			<TextCell value={refund.creationDateFormatted} />
			{showPrices && <KOGTableCell align="right">{formatCurrency(refund.price)}</KOGTableCell>}
		</KOGTableRow>
	);
}
